import axios from 'axios';

const ExamPrep = {
	namespaced: true,
	actions: {
		CreateExamQuestion({ rootState }, payload) {
			return new Promise((resolve, reject) => {
				const headers = {
					Authorization: `bearer ${rootState.auth.token}`,
				};
				axios
					.post(
						`${process.env.VUE_APP_ENV_API_URL}ExamPrep/CreateExamQuestion`,
						payload,
						{ headers }
					)
					.then((resp) => resp.data)
					.then((data) => {
						resolve(data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		UpdateExamQuestion({ rootState }, payload) {
			return new Promise((resolve, reject) => {
				const headers = {
					Authorization: `bearer ${rootState.auth.token}`,
				};
				axios
					.post(
						`${process.env.VUE_APP_ENV_API_URL}ExamPrep/UpdateExamQuestion`,
						payload,
						{ headers }
					)
					.then((resp) => resp.data)
					.then((data) => {
						resolve(data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		CreateExam({ rootState }, payload) {
			return new Promise((resolve, reject) => {
				const headers = {
					Authorization: `bearer ${rootState.auth.token}`,
				};
				axios
					.post(
						`${process.env.VUE_APP_ENV_API_URL}ExamPrep/CreateExam`,
						payload,
						{ headers }
					)
					.then((resp) => resp.data)
					.then((data) => {
						resolve(data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		UpdateExam({ rootState }, payload) {
			return new Promise((resolve, reject) => {
				const headers = {
					Authorization: `bearer ${rootState.auth.token}`,
				};
				axios
					.post(
						`${process.env.VUE_APP_ENV_API_URL}ExamPrep/UpdateExam`,
						payload,
						{ headers }
					)
					.then((resp) => resp.data)
					.then((data) => {
						resolve(data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		CreateExamSubject({ rootState }, payload) {
			return new Promise((resolve, reject) => {
				const headers = {
					Authorization: `bearer ${rootState.auth.token}`,
				};
				axios
					.post(
						`${process.env.VUE_APP_ENV_API_URL}ExamPrep/CreateExamSubject`,
						payload,
						{ headers }
					)
					.then((resp) => resp.data)
					.then((data) => {
						resolve(data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		UpdateExamSubject({ rootState }, payload) {
			return new Promise((resolve, reject) => {
				const headers = {
					Authorization: `bearer ${rootState.auth.token}`,
				};
				axios
					.post(
						`${process.env.VUE_APP_ENV_API_URL}ExamPrep/UpdateExamSubject`,
						payload,
						{ headers }
					)
					.then((resp) => resp.data)
					.then((data) => {
						resolve(data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		GetExams({ rootState }, { SchoolTypeId }) {
			return new Promise((resolve, reject) => {
				const headers = {
					Authorization: `bearer ${rootState.auth.token}`,
				};
				axios
					.get(
						`${process.env.VUE_APP_ENV_API_URL}ExamPrep/PortalGetExams?SchoolTypeId=${SchoolTypeId}`,
						{ headers }
					)
					.then((resp) => resp.data)
					.then((data) => {
						resolve(data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		GetExamById({ rootState }, ExamId) {			
			return new Promise((resolve, reject) => {
				const headers = {
					Authorization: `bearer ${rootState.auth.token}`,
				};
				axios
					.get(
						`${process.env.VUE_APP_ENV_API_URL}ExamPrep/PortalGetExamById?ExamId=${ExamId}`,
						{ headers }
					)
					.then((resp) => resp.data)
					.then((data) => {
						resolve(data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		GetExamSubjects({ rootState }, ExamId ) {
			return new Promise((resolve, reject) => {
				const headers = {
					Authorization: `bearer ${rootState.auth.token}`,
				};
				axios
					.get(
						`${process.env.VUE_APP_ENV_API_URL}ExamPrep/PortalGetExamSubjects?ExamId=${ExamId}`,
						{ headers }
					)
					.then((resp) => resp.data)
					.then((data) => {
						resolve(data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		GetExamSubjectById({ rootState }, ExamSubjectId ) {
			return new Promise((resolve, reject) => {
				const headers = {
					Authorization: `bearer ${rootState.auth.token}`,
				};
				axios
					.get(
						`${process.env.VUE_APP_ENV_API_URL}ExamPrep/PortalGetExamSubjectById?ExamSubjectId=${ExamSubjectId}`,
						{ headers }
					)
					.then((resp) => resp.data)
					.then((data) => {
						resolve(data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		GetExamYears({ rootState }) {
			return new Promise((resolve, reject) => {
				const headers = {
					Authorization: `bearer ${rootState.auth.token}`,
				};
				axios
					.get(
						`${process.env.VUE_APP_ENV_API_URL}ExamPrep/PortalGetExamYears`,
						{ headers }
					)
					.then((resp) => resp.data)
					.then((data) => {
						resolve(data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		GetExamQuestions({ rootState }, { ExamSubjectId, ExamYearId }) {
			return new Promise((resolve, reject) => {
				const headers = {
					Authorization: `bearer ${rootState.auth.token}`,
				};
				axios
					.get(
						`${process.env.VUE_APP_ENV_API_URL}ExamPrep/PotalGetExamQuestions?ExamSubjectId=${ExamSubjectId}&ExamYearId=${ExamYearId}`,
						{ headers }
					)
					.then((resp) => resp.data)
					.then((data) => {
						resolve(data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		GetExamQuestionById({ rootState }, ExamQuestionId) {
			return new Promise((resolve, reject) => {
				const headers = {
					Authorization: `bearer ${rootState.auth.token}`,
				};
				axios
					.get(
						`${process.env.VUE_APP_ENV_API_URL}ExamPrep/PortalGetExamQuestionById?ExamQuestionId=${ExamQuestionId}`,
						{ headers }
					)
					.then((resp) => resp.data)
					.then((data) => {
						resolve(data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
	}
}

export default ExamPrep